const IMAGE_SIZE = 400;
const LENS_SIZE = 240;
const ZOOM_SIZE = 600;
const RATIO = ZOOM_SIZE / LENS_SIZE;

const getCursorPosition = (event, { image }) => {
  const x = event.pageX - image.left - window.pageXOffset;
  const y = event.pageY - image.top - window.pageYOffset;

  return { x: x, y: y };
};

const calcPosition = (cursor, ratio) => (cursor > ratio ? ratio : cursor);

export const handleZoom = (dispatch, state) => e => {
  e.preventDefault();
  const cursor = getCursorPosition(e, state);

  const cursorPositionX = cursor.x - LENS_SIZE / 2;
  const cursorPositionY = cursor.y - LENS_SIZE / 2;
  const imageLensRatio = IMAGE_SIZE - LENS_SIZE;

  const x = cursorPositionX < 0 ? 0 : calcPosition(cursorPositionX, imageLensRatio);
  const y = cursorPositionY < 0 ? 0 : calcPosition(cursorPositionY, imageLensRatio);

  dispatch({ active: true, lens: { x, y }, zoom: { x: x * RATIO, y: y * RATIO } });
};

export const handleInit = dispatch => e => {
  e.preventDefault();

  const image = e.target.getBoundingClientRect();

  dispatch({ active: true, image });
};

export const handleLeave = dispatch => e => dispatch({ active: false });

export const zoomReducer = (state, action) => ({ ...state, ...action });
